export default {
  meta: {
    title: '踩点记录' // 随手记功能，客户要求暂定以踩点记录命名
  }
};
